export interface CombatSkill {
  id: string;
  name: string;
  description: string;
  damageMin: number;
  damageMax: number;
  manaCost: number;
  cooldown: number;
  type: 'physical' | 'magical' | 'support';
  effect?: string;
}

export interface Enemy {
  id: string;
  name: string;
  level: number;
  health: number;
  maxHealth: number;
  mana: number;
  maxMana: number;
  attack: number;
  defense: number;
  experience: number;
  gold: number;
  loot: string[];
}

export const COMBAT_SKILLS: CombatSkill[] = [
  {
    id: 'skill-slash',
    name: 'Slash',
    description: 'A powerful melee attack',
    damageMin: 15,
    damageMax: 25,
    manaCost: 0,
    cooldown: 0,
    type: 'physical',
  },
  {
    id: 'skill-fireball',
    name: 'Fireball',
    description: 'Cast a ball of flames',
    damageMin: 20,
    damageMax: 35,
    manaCost: 30,
    cooldown: 3,
    type: 'magical',
    effect: 'burn',
  },
  {
    id: 'skill-defensive-stance',
    name: 'Defensive Stance',
    description: 'Reduce incoming damage',
    damageMin: 0,
    damageMax: 0,
    manaCost: 15,
    cooldown: 2,
    type: 'support',
    effect: 'shield',
  },
  {
    id: 'skill-heal',
    name: 'Heal',
    description: 'Restore health',
    damageMin: 0,
    damageMax: 0,
    manaCost: 25,
    cooldown: 4,
    type: 'support',
    effect: 'restore-health',
  },
  {
    id: 'skill-power-strike',
    name: 'Power Strike',
    description: 'A devastating physical blow',
    damageMin: 30,
    damageMax: 50,
    manaCost: 20,
    cooldown: 4,
    type: 'physical',
  },
];

export const ENEMIES: Enemy[] = [
  {
    id: 'enemy-shadow-beast',
    name: 'Shadow Beast',
    level: 1,
    health: 50,
    maxHealth: 50,
    mana: 20,
    maxMana: 20,
    attack: 12,
    defense: 5,
    experience: 100,
    gold: 50,
    loot: ['Shadow Fur', 'Beast Fang'],
  },
  {
    id: 'enemy-corrupted-mage',
    name: 'Corrupted Mage',
    level: 2,
    health: 60,
    maxHealth: 60,
    mana: 40,
    maxMana: 40,
    attack: 15,
    defense: 8,
    experience: 150,
    gold: 75,
    loot: ['Arcane Tome', 'Mana Crystal'],
  },
  {
    id: 'enemy-void-knight',
    name: 'Void Knight',
    level: 3,
    health: 80,
    maxHealth: 80,
    mana: 30,
    maxMana: 30,
    attack: 18,
    defense: 12,
    experience: 200,
    gold: 100,
    loot: ['Obsidian Armor', 'Dark Essence'],
  },
];
